import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  getButtonHover,
  getColor,
  getDarkenColor,
} from '../../../utils/helper';

const StyledButton = ({
  loading,
  children,
  icon,
  textButton,
  childrenProps,
  loaderClass = 'me-2',
  svgStyle = false,
  ...props
}) => {
  if (textButton) {
    return (
      <TextButtonStyled {...props} _children={children}>
        {children}
      </TextButtonStyled>
    );
  }

  return (
    <ButtonStyled svgStyle={svgStyle} {...props} _children={children} >
      <span
        className={`spinner spinner-border spinner-border-sm ${loaderClass} ${
          !loading ? 'd-none' : 'd-inline-block'
        }`}
        style={{
          transition: 'all 0.3s linear',
          borderWidth: '3px',
        }}
      />
      {icon && !loading && (
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            marginRight: children ? 10 : 0,
          }}
        >
          {icon}
        </span>
      )}
      <span
        style={{
          transition: 'margin-left 0.3s ease-in',
        }}
        {...childrenProps}
      >
        {children}
      </span>
    </ButtonStyled>
  );
};

const ButtonStyled = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ $fontSize }) => $fontSize ?? 'inherit'};
  font-weight: ${({ $fontWeight }) => $fontWeight ?? '400'};
  color: ${({ color, theme, variant }) =>
    variant === 'outline' ? getColor(color, theme) : theme.white};
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: ${({ color, theme, variant }) =>
    variant !== 'outline' ? getColor(color, theme) : 'transparent'};
  border: 2px solid ${({ color, theme }) => getColor(color, theme)};
  padding: ${({ $paddingY }) => ($paddingY ? $paddingY : '0.7rem')}
    ${({ $paddingX }) => ($paddingX ? $paddingX : '0.9rem')};
  line-height: 1.5;
  border-radius: 0.5rem;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s,
    box-shadow 0.15s;

    ${({ svgStyle, color, theme, variant }) =>
    svgStyle &&
    `
    svg path {
      stroke: ${variant === 'outline' ? getColor(color, theme) : theme.white};
    }
  `}

  &:hover {
    background-color: ${({ color, theme }) => getDarkenColor(color, theme)};
    color: ${({ color, theme, variant }) =>
      variant !== 'outline' ? getButtonHover(color, theme) : theme.white};

    ${({ svgStyle, color, theme, variant }) =>
      svgStyle &&
      `
        svg path {
          stroke: ${variant !== 'outline' ? getButtonHover(color, theme) : theme.white} !important;
        }
      `}
  }

  &.active {
    background-color: ${({ color, theme }) => getDarkenColor(color, theme)};
    color: ${({ color, theme, variant }) =>
      variant !== 'outline' ? getButtonHover(color, theme) : theme.white};
  }

  &:focus {
    outline: 0;
  }

  &:not(:disabled):not(.disabled) {
    cursor: pointer;
  }

  &:disabled,
  &.disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &.border-none{
    border none;
  }

  @media (max-width: 500px) {
    padding: 5px 10px !important;
  }
`;

const TextButtonStyled = styled.button`
  color: ${({ color, theme }) => getColor(color, theme)};
  background-color: transparent;
  border: none;
  padding: 0;
  font-size: ${({ $fontSize }) => $fontSize ?? 'inherit'};
  font-weight: ${({ $fontWeight }) => $fontWeight ?? '400'};
  line-height: inherit;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: 0;
  }

  &:disabled,
  &.disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

StyledButton.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.any,
  icon: PropTypes.element,
};
export default StyledButton;
